import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import UserAvatarImage from '../../components/user-avatar-image';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './promote-user-details.scss';

const PromoteUserDetails = ({ contentFontClassName, user }) =>
  <div className={classNames(styles.container, contentFontClassName, 'forum-text-color')}>
    <UserAvatarImage type="promote" user={user}/>
    <h3 className={styles.name}>
      {user.name}
    </h3>
  </div>;

PromoteUserDetails.propTypes = {
  contentFontClassName: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default withFontClassName(PromoteUserDetails);



// WEBPACK FOOTER //
// ./app/components/promote-user-details/promote-user-details.js